import React from "react";
import classes from "./StretchHeaderImage.module.css";

const StretchHeaderImage = ({ imageSource, imageAlt }) => {
   return <img className={classes.page_header_image} src={imageSource} alt={imageAlt} />
}

export default StretchHeaderImage;